module.exports = __webpack_public_path__ + "img/humen.9d8c7acd.svg";